import React from 'react';
import { Box, CardMedia, Container, Typography } from '@mui/material';
import { Paragraph, Title } from '../../pages/auth/styled';
import { MasterMessage } from '../../../masters/masterMessages';
import imageNotFound from '../../../assets/images/pageNotFound/image404.jpg';

const PageNotFound = () => {
    const { title, subTitle, messsage } = MasterMessage.pageNotFound;

    return (
        <Box id="Page Not Found">
            <Container maxWidth="md" style={{ marginTop: 20 }}>
                <Box mt={8}>
                    <Title variant="h4">{title}</Title>
                    <CardMedia
                        component="img"
                        src={imageNotFound}
                        alt="logo-sg"
                        sx={{ mt: 2 }}
                    />
                    <Paragraph>{subTitle}</Paragraph>
                    <Typography
                        align="center"
                        variant="subtitle2"
                        color="textSecondary"
                    >
                        {messsage}
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default PageNotFound;
